// extracted by mini-css-extract-plugin
export default {"gait_table":"GaitTable_gait_table__E7Chd","accession_label":"GaitTable_accession_label__zmpGK"};